import { Col, Flex, Row, Tooltip } from 'antd';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { TaskAssignment } from 'types/common';
import { getStatusValues } from 'utils/helpers';

type TaskStatusListProps = {
  tasks: TaskAssignment[];
  onClickTask: (task: TaskAssignment) => void;
};

type TaskStatusProps = {
  status?: string;
  tooltip?: string;
  onClick?: () => void;
};

const TaskStatus = ({ status, tooltip, onClick }: TaskStatusProps) => {
  const {
    icon: IconElement,
    text,
    toolTipIcon: TooltipIconElement,
    iconColor,
  } = getStatusValues(status) || {};

  if (!IconElement || !TooltipIconElement) return null;

  const toolTipContent = (
    <>
      <Flex justify="center" align="center">
        {tooltip}
      </Flex>
      <Flex className="task-tooltip" justify="center" align="center" gap={5}>
        <TooltipIconElement />
        {text}
      </Flex>
    </>
  );

  return (
    <Tooltip title={toolTipContent}>
      <Col
        sm={4}
        className="flex-center clickable"
        onClick={onClick}
        style={iconColor ? { color: iconColor } : undefined}
      >
        <IconElement />
      </Col>
    </Tooltip>
  );
};

export const sortTasksBySubType = (tasks: TaskAssignment[]) => {
  const taskOrder: {
    [key: string]: number;
  } = {
    MACHINE_SERVICE: 1,
    START_SEASON: 2,
    FERTILIZER_LOG: 3,
    PIPE_INSTALLATION_DATE: 4,
    PIPE_INSTALLATION: 5,
    VISIT_30: 6,
    DRYING_EVENT_1: 7,
    DRYING_EVENT_2: 8,
    DRYING_EVENT_3: 9,
    PRE_HARVEST_MEETING: 10,
    HARVEST: 11,
  };

  return [...tasks].sort((a, b) => {
    const orderA = taskOrder[a.taskSubType] || 999;
    const orderB = taskOrder[b.taskSubType] || 999;
    const res = orderA - orderB;
    if (res != 0) return res;

    return dayjs(a.dueDate).valueOf() - dayjs(b.dueDate).valueOf();
  });
};

const TaskStatusList = ({ tasks, onClickTask }: TaskStatusListProps) => {
  const { t } = useTranslation();
  return (
    <Row gutter={[8, 8]}>
      {tasks?.length > 0 ? (
        sortTasksBySubType(tasks).map((task, index) => (
          <TaskStatus
            key={task?.id + index}
            status={task?.status}
            tooltip={task?.description}
            onClick={() => onClickTask(task)}
          />
        ))
      ) : (
        <TaskStatus
          status="Inactive"
          tooltip={t('dashboard.noTasksAvailable')}
        />
      )}
    </Row>
  );
};

export default TaskStatusList;
